import { mock, intercepter } from '../config';

mock.mock('/auth/forgot-password', 'post', intercepter(null));
